import { cn } from "@/lib/utils";
import { useTranslation } from "react-i18next";

export interface EmptyStateProps {
  title?: string;
  description?: string;
  image?: string;
  className?: string;
}

export function EmptyState({
  title,
  description,
  image,
  className,
}: EmptyStateProps) {
  const { t } = useTranslation();

  return (
    <div
      className={cn(
        "flex flex-col items-center justify-start h-full",
        className
      )}
    >
      {image && <img src={image} alt={title} className="w-auto h-1/2" />}

      <h1 className="text-2xl font-bold text-center">
        {title || t("common.emptyState.title")}
      </h1>

      {description && (
        <p className="text-gray-500 text-center">{description}</p>
      )}
    </div>
  );
}
